if (!customElements.get('ugc-carousel')) {
  class UgcCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ugc-carousel__track');
      this.tiles = Array.from(this.querySelectorAll('.ugc-carousel__tile'));

      this.setupScrollbar();

      this.tiles.forEach((tile) => {
        const video = tile.querySelector('video');
        if (!video) return;

        tile.addEventListener('click', () => {
          if (video.paused) {
            this.loadVideo(video);
            this.pauseAll(tile);
            video.muted = false;
            video.play();
            tile.classList.add('is-playing');
          } else {
            video.pause();
            tile.classList.remove('is-playing');
          }
        });

        video.addEventListener('ended', () => tile.classList.remove('is-playing'));
      });

      this.querySelectorAll('.ugc-carousel__nav-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const direction = Number(btn.dataset.direction);
          const tileWidth = this.tiles[0] ? this.tiles[0].offsetWidth + 16 : 260;
          this.track.scrollBy({ left: direction * tileWidth * 2, behavior: 'smooth' });
        });
      });
    }

    // A thin progress bar under the track hinting that it scrolls
    // horizontally, since the native scrollbar is hidden.
    setupScrollbar() {
      this.scrollbarThumb = this.querySelector('.ugc-carousel__scrollbar-thumb');
      if (!this.scrollbarThumb) return;

      const update = () => {
        const trackWidth = this.track.clientWidth;
        const scrollWidth = this.track.scrollWidth;
        if (!scrollWidth) return;
        const ratio = Math.min(1, trackWidth / scrollWidth);
        const maxScroll = scrollWidth - trackWidth;
        const progress = maxScroll > 0 ? this.track.scrollLeft / maxScroll : 0;
        this.scrollbarThumb.style.width = ratio * 100 + '%';
        this.scrollbarThumb.style.left = progress * (1 - ratio) * 100 + '%';
      };

      this.track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    // Only called from the click handler now - a real mobile Lighthouse
    // run showed the previous IntersectionObserver-triggered version of
    // this (firing as a tile scrolled near view, not on tap) downloading
    // several megabytes per video instead of the expected few KB, since
    // several of these clips aren't "fast start" encoded (moov atom not
    // at the front, so even preload="metadata" has to fetch nearly the
    // whole file). Loading only ever happens on an explicit tap now, and
    // play() is called immediately after regardless of this hint.
    loadVideo(video) {
      if (!video.dataset.lazySrc) return;
      video.src = video.dataset.lazySrc;
      video.preload = 'metadata';
      delete video.dataset.lazySrc;
    }

    pauseAll(except) {
      this.tiles.forEach((tile) => {
        if (tile === except) return;
        const video = tile.querySelector('video');
        if (video && !video.paused) video.pause();
        tile.classList.remove('is-playing');
      });
    }
  }

  customElements.define('ugc-carousel', UgcCarousel);
}
